import {atom, selector} from "recoil";

const firebaseState = atom({
  key: 'firebaseState',
  default: {
    uid: null,
    sessionId: null,
    connected: false,
    user: null,
  }
});

export const firebaseUidState = selector({
  key: 'firebaseUidState',
  get: ({get}) => {
    return get(firebaseState).uid
  }
})
export const firebaseSessionIdState = selector({
  key: 'firebaseSessionIdState',
  get: ({get}) => {
    return get(firebaseState).sessionId
  }
})
export const connectedState = selector({
  key: 'connectedState',
  get: ({get}) => {
    return get(firebaseState).connected
  }
})
export const firebaseUserState = selector({
  key: 'firebaseUserState',
  get: ({get}) => {
    return get(firebaseState).user
  }
})
export const firebaseClaimsState = selector({
  key: 'firebaseClaimsState',
  get: ({get}) => {
    return get(firebaseState).claims;
  }
})

export default firebaseState;
